export const base_url = "https://5nsqw6dttc.execute-api.ap-south-1.amazonaws.com/dev/api/";
export const wss_url = "wss://0498gbz864.execute-api.ap-south-1.amazonaws.com/production/"
// export const base_url = process.env.REACT_APP_BASE_URL;
